import axios from "axios";
import config from "../config";
import { getAccessToken } from "../utils";
import { handleApiError } from "../components/errorBoundary/errorUtils";

const currentDomain = process.env.REACT_APP_DOMAIN;
const domainConfig = config[currentDomain];
const endpoint = domainConfig.apiEndpoint;

export const fetchProjectsApi = async (username) => {
  try {
    const accessToken = getAccessToken();
    const response = await axios.get(
      `${endpoint}project/getProject/?username=${username}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data.data;
  } catch (error) {
    return handleApiError(error);
  }
};
